import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppGuard } from '../app.guard';
import { RootDashboardComponent } from './root-dashboard/root-dashboard.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DashboardEmployeeComponent } from './pages/dashboard-employee/dashboard-employee.component';
import { EmployeeHomeComponent } from './pages/employee-home/employee-home.component';
import { EmployeeProfileComponent } from './pages/employee-profile/employee-profile.component';
import { EmployeeListComponent } from './pages/employee-list/employee-list.component';
import { PendingRequestComponent } from './pages/pending-request/pending-request.component';
import { LoanApprovalComponent } from './pages/loan-approval/loan-approval.component';
import { ReportPageComponent } from './pages/report-page/report-page.component';
import { EmployeeDetailsComponent } from './pages/employee-details/employee-details.component';
import { PayrollDatesComponent } from './pages/payroll-dates/payroll-dates.component';
import { PermanentSavingsParametersComponent } from './pages/permanent-savings-parameters/permanent-savings-parameters.component';
import { PermanentSavingsLoanParametersComponent } from './pages/permanent-savings-loan-parameters/permanent-savings-loan-parameters.component';
import { PermanentInstallmentParametersComponent } from './pages/permanent-installment-parameters/permanent-installment-parameters.component';
import { PermanentSavingInvestmentsComponent } from './pages/permanent-saving-investments/permanent-saving-investments.component';
import { RetirementSavingsLoanParametersComponent } from './pages/retirement-savings-loan-parameters/retirement-savings-loan-parameters.component';
import { RetirementSavingParametersComponent } from './pages/retirement-saving-parameters/retirement-saving-parameters.component';
import { SavingFundParametersComponent } from './pages/saving-fund-parameters/saving-fund-parameters.component';
import { PendingListComponent } from './pages/pending-list/pending-list.component';
import { PendingListParametersComponent } from './pages/pending-list-parameters/pending-list-parameters.component';
import { LoansWaitingListComponent } from './pages/loans-waiting-list/loans-waiting-list.component';
import { SsRegistrationComponent } from './components/share-saving/ss-registration/ss-registration.component';
import { ShareSavingParametersComponent } from './pages/share-saving-parameters/share-saving-parameters.component';
import { SsApprovalComponent } from './components/share-saving/ss-approval/ss-approval.component';
import { VeabRegistrationComponent } from './components/veab-registration/veab-registration.component';

const routes: Routes = [
  {
    path: 'employee',
    component: RootDashboardComponent,
    canActivate: [AppGuard],
    children: [
      {
        path: 'home',
        component: DashboardEmployeeComponent
      },
      {
        path: 'detail',
        component: EmployeeHomeComponent
      },
      {
        path: 'profile',
        component: EmployeeProfileComponent
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'supervisor',
    component: RootDashboardComponent,
    canActivate: [AppGuard],
    children: [
      {
        path: 'employee-list',
        component: EmployeeListComponent
      },
      {
        path: 'pending-requests',
        component: PendingRequestComponent
      },
      {
        path: 'pending-requests/loan-approval/:id',
        component: LoanApprovalComponent
      },
      {
        path: 'employee-list/employee-details/:id',
        component: EmployeeDetailsComponent
      },
      {
        path: 'employee-list/dashboard/:id',
        component: DashboardComponent
      },
      {
        path: '',
        redirectTo: 'employee-list',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'administrator',
    component: RootDashboardComponent,
    canActivate: [AppGuard],
    children: [
      {
        path: 'employee-list',
        component: EmployeeListComponent
      }, {
        path: 'employee-list/employee-details/:id',
        component: EmployeeDetailsComponent
      },
      {
        path: 'employee-list/dashboard/:id',
        component: DashboardComponent
      },
      {
        path: 'pending-list',
        component: PendingListComponent
      },
      {
        path: 'pending-requests',
        component: PendingRequestComponent
      },
      {
        path: 'pending-requests/loan-approval/:id',
        component: LoanApprovalComponent
      },
      {
        path: 'loans-waiting-list',
        component: LoansWaitingListComponent
      },
      {
        path: 'reports',
        component: ReportPageComponent
      },
      {
        path: 'permanent-saving-parameters',
        component: PermanentSavingsParametersComponent
      },
      {
        path: 'permanent-savings-loan-parameters',
        component: PermanentSavingsLoanParametersComponent
      },
      {
        path: 'permanent-installment-parameters',
        component: PermanentInstallmentParametersComponent
      },
      {
        path: 'saving-investments',
        component: PermanentSavingInvestmentsComponent
      },
      {
        path: 'retirement-saving-parameters',
        component: RetirementSavingParametersComponent
      },
      {
        path: 'retirement-savings-loan-parameters',
        component: RetirementSavingsLoanParametersComponent
      },
      {
        path: 'pending-list-parameters',
        component: PendingListParametersComponent
      },
      {
        path: 'saving-fund',
        component: SavingFundParametersComponent
      },
      {
        path: 'share-saving',
        component: SsRegistrationComponent
      },
      {
        path: 'share-saving-parameters',
        component: ShareSavingParametersComponent

      },
      {
        path: 'share-saving-aproval',
        component: SsApprovalComponent

      },
      {
        path: 'payroll-dates',
        component: PayrollDatesComponent
      },
      {
        path: 'veab-bonus',
        component: VeabRegistrationComponent
      },
      {
        path: '',
        redirectTo: 'employee-list',
        pathMatch: 'full'
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticatedRoutingModule { }